import React, { useEffect } from "react";
import styles from "./Loader.module.scss";

const Loader = () => {
  useEffect(() => {
    return async function cleanup() {
      return await new Promise((resolve) => setTimeout(() => resolve(), 5000));
    };
  });

  return (
    <div className={styles.Container}>
      <div className={styles.Spinner}>
        <div
          className={"spinner-border text-primary " + styles.SpinnerEl}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
